import React, { memo } from "react"
import MuiLinearProgress from "@material-ui/core/LinearProgress"
import { makeStyles } from "@material-ui/styles"
import { Box } from "@material-ui/core"
import { RowBox } from "../Boxes"

const useLinearProgressStyles = makeStyles((theme) => ({
  root: {
    height: 10,
    backgroundColor: ({ overdue, complete, primaryColor }) =>
      overdue
        ? `rgba(${theme.palette.error.mainRgb},.15)`
        : complete
          ? `rgba(${theme.palette.success.mainRgb},.15)`
          : primaryColor
            ? `rgba(${theme.palette.primary.mainRgb},.15)`
            : `rgba(${theme.palette.info.mainRgb},.15)`,
    borderRadius: 20,
    width: "auto"
  },
  bar: {
    borderRadius: 20
  },
  barColorPrimary: {
    backgroundColor: ({ complete, overdue, primaryColor }) =>
      overdue
        ? theme.palette.error.main
        : complete
          ? theme.palette.success.main
          : primaryColor
            ? theme.palette.primary.main
            : theme.palette.info.main
  },
  barColorSecondary: {
    backgroundColor: theme.palette.success.main
  }
}))

const useStyles = makeStyles((theme) => ({
  progress: {
    flex: 1,
    marginRight: ({ showValue }) => (showValue ? 10 : 0)
  },
  value: {
    color: ({ complete, overdue, primaryColor }) =>
      overdue
        ? theme.palette.error.main
        : complete
          ? theme.palette.success.main
          : primaryColor
            ? theme.palette.primary.main
            : theme.palette.info.main,
    fontSize: 13,
    fontWeight: "600",
    lineHeight: "16px"
  }
}))

const LinearProgress = memo(function LinearProgress({
  value,
  showValue,
  overdue,
  title,
  className,
  onClick,
  primaryColor
}) {
  const complete = value === 100
  const classes = useStyles({ complete, overdue, showValue, primaryColor })
  const progressClasses = useLinearProgressStyles({ complete, overdue, primaryColor })

  const handleClick = () => {
    onClick && onClick()
  }

  return (
    <RowBox alignItems="center" title={title} className={className} onClick={handleClick}>
      <Box className={classes.progress}>
        <MuiLinearProgress
          variant="determinate"
          value={value}
          color={!complete ? "primary" : "secondary"}
          classes={progressClasses}
        />
      </Box>
      {showValue && <Box className={classes.value}>{value}%</Box>}
    </RowBox>
  )
})

export { LinearProgress }
